namespace RioERP.Reports {
    export interface InvoiceDetailedReportForm {
        InvoiceDate: Serenity.DateEditor;
        OrderDate: Serenity.DateEditor;
        Invoicenumber: Serenity.StringEditor;
        EPaymentType: Serenity.EnumEditor;
        CustomerName: Serenity.StringEditor;
        EInvoiceTo: Serenity.IntegerEditor;
        FranchiseeName: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        TaxCategoryName: Serenity.StringEditor;
        InvoiceCompanyId: Serenity.LookupEditor;
        OrderNumber: Serenity.StringEditor;
        SpecificationName: Serenity.StringEditor;
        Views: Serenity.EnumEditor;
        Validity: Serenity.EnumEditor;
        Quantity: Serenity.IntegerEditor;
        OrderProductBillingItemsId: Serenity.IntegerEditor;
        FranchiseeDiscountAmount: Serenity.DecimalEditor;
        City: Serenity.StringEditor;
        FranchiseeId: Serenity.LookupEditor;
        CustomerId: Serenity.LookupEditor;
        ProductId: Serenity.IntegerEditor;
        HsnCode: Serenity.StringEditor;
        InvoiceId: Serenity.LookupEditor;
        EPaymentStatus: Serenity.EnumEditor;
        DiscountAmount: Serenity.DecimalEditor;
        Amount: Serenity.DecimalEditor;
        TotalTax: Serenity.DecimalEditor;
        OrderDiscount: Serenity.DecimalEditor;
        ProductDiscount: Serenity.DecimalEditor;
        Total: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        CgstRate: Serenity.DecimalEditor;
        CgstAmount: Serenity.DecimalEditor;
        SgstRate: Serenity.DecimalEditor;
        SgstAmount: Serenity.DecimalEditor;
        IgstRate: Serenity.DecimalEditor;
        IgstAmount: Serenity.DecimalEditor;
        StateName: Serenity.StringEditor;
        Gstin: Serenity.StringEditor;
        TransactionId: Serenity.StringEditor;
    }

    export class InvoiceDetailedReportForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.InvoiceDetailedReport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!InvoiceDetailedReportForm.init)  {
                InvoiceDetailedReportForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.EnumEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.LookupEditor;
                var w5 = s.DecimalEditor;

                Q.initFormType(InvoiceDetailedReportForm, [
                    'InvoiceDate', w0,
                    'OrderDate', w0,
                    'Invoicenumber', w1,
                    'EPaymentType', w2,
                    'CustomerName', w1,
                    'EInvoiceTo', w3,
                    'FranchiseeName', w1,
                    'ProductName', w1,
                    'TaxCategoryName', w1,
                    'InvoiceCompanyId', w4,
                    'OrderNumber', w1,
                    'SpecificationName', w1,
                    'Views', w2,
                    'Validity', w2,
                    'Quantity', w3,
                    'OrderProductBillingItemsId', w3,
                    'FranchiseeDiscountAmount', w5,
                    'City', w1,
                    'FranchiseeId', w4,
                    'CustomerId', w4,
                    'ProductId', w3,
                    'HsnCode', w1,
                    'InvoiceId', w4,
                    'EPaymentStatus', w2,
                    'DiscountAmount', w5,
                    'Amount', w5,
                    'TotalTax', w5,
                    'OrderDiscount', w5,
                    'ProductDiscount', w5,
                    'Total', w5,
                    'NetAmount', w5,
                    'TaxableAmount', w5,
                    'CgstRate', w5,
                    'CgstAmount', w5,
                    'SgstRate', w5,
                    'SgstAmount', w5,
                    'IgstRate', w5,
                    'IgstAmount', w5,
                    'StateName', w1,
                    'Gstin', w1,
                    'TransactionId', w1
                ]);
            }
        }
    }
}
